import type { Options } from 'qr-code-styling';
import type { QRConfig } from '../store/useAppStore';

export const getQROptions = (width: number, content: string, config: QRConfig, logoFile?: string | null, forceTransparentBg = false): Options => {
  const dotsOptions: Options['dotsOptions'] = {
    type: config.moduleShape,
  };
  if (config.foregroundType === 'solid') {
    if (config.foregroundColor) dotsOptions.color = config.foregroundColor;
  } else {
    dotsOptions.gradient = {
      type: config.foregroundType === 'linear-gradient' ? 'linear' : 'radial',
      colorStops: [
        { offset: 0, color: config.gradientColor1 },
        { offset: 1, color: config.gradientColor2 },
      ],
      rotation: config.foregroundType === 'linear-gradient' ? (config.gradientDirection * Math.PI) / 180 : 0,
    };
  }

  const cornersSquareOptions: Options['cornersSquareOptions'] = {
    type: config.cornerShape,
  };
  if (config.cornerColor) cornersSquareOptions.color = config.cornerColor;

  const cornersDotOptions: Options['cornersDotOptions'] = {
    type: config.eyeInnerShape,
  };
  if (config.eyeInnerColor) cornersDotOptions.color = config.eyeInnerColor;

  const options: Options = {
    width,
    height: width,
    data: content || 'https://example.com',
    margin: Math.max(16, Math.round(width * 0.08)),
    qrOptions: { errorCorrectionLevel: config.errorCorrection },
    imageOptions: {
      hideBackgroundDots: true,
      imageSize: config.logoSize / 100,
      margin: config.logoMargin,
      crossOrigin: 'anonymous',
    },
    dotsOptions,
    backgroundOptions: { color: forceTransparentBg || config.backgroundTransparent ? 'transparent' : config.backgroundColor },
    cornersSquareOptions,
    cornersDotOptions,
  };

  if (logoFile) options.image = logoFile;

  return options;
};

export const getFrameMetrics = (width: number, frameStyle: string) => {
  const frameHeight = frameStyle !== 'none' ? Math.max(32, Math.round(width * 0.12)) : 0;
  const radius = frameHeight * 0.4;
  const fontSize = Math.max(12, Math.min(48, Math.round(frameHeight * 0.45)));
  return { frameHeight, radius, fontSize };
};

export const getRoundedFramePathString = (width: number, frameHeight: number, radius: number): string => {
  const y = width;
  return `M0,${y} L${width},${y} L${width},${y + frameHeight - radius} A${radius},${radius} 0 0,1 ${width - radius},${y + frameHeight} L${radius},${y + frameHeight} A${radius},${radius} 0 0,1 0,${y + frameHeight - radius} Z`;
};
